import { Module } from '@/modules/core/app/constants/app.constants';
import { ProposalName, ProposalRoute } from '@/modules/to/adfloproposal/proposal.constants';
import { ProposalRouteConfig } from '@/modules/to/adfloproposal/ProposalRouteConfig';

export const router = ProposalRouteConfig.factory(
  [
    {
      path: ProposalRoute.PROPOSALS,
      name: ProposalName.PROPOSALS,
      component: () => import(/* webpackChunkName: "proposals-page" */ `./pages/Proposals.vue`),
    },
    {
      path: ProposalRoute.PROPOSAL_CREATE,
      name: ProposalName.PROPOSAL_CREATE,
      component: () => import(/* webpackChunkName: "proposal-page" */ `./pages/Proposal.vue`),
    },
    {
      path: ProposalRoute.PROPOSAL_RENEWAL,
      name: ProposalName.PROPOSAL_RENEWAL,
      component: () =>
        import(/* webpackChunkName: "proposal-renewal-page" */ `./pages/RenewalSelection.vue`),
    },
    {
      path: ProposalRoute.PROPOSAL_DETAILS,
      name: ProposalName.PROPOSAL_DETAILS,
      component: () => import(/* webpackChunkName: "proposal-page" */ `./pages/Proposal.vue`),
    },
  ],
  Module.ADFLO_PROPOSAL
);
